import { useQuery } from "@tanstack/react-query";
import { Download } from "lucide-react";
import { api, readCookie } from "../api/client";
import { ErrorState, LoadingState } from "../components/AsyncState";
import { PageHeader } from "../components/PageHeader";
import { formatNumber } from "../lib/format";

type ReportRow = {
  unit_name: string;
  households: number;
  received: number;
  never_received: number;
  average_wait_days: number | null;
};
export function ReportsPage() {
  const query = useQuery({
    queryKey: ["delivery-report"],
    queryFn: async () => (await api<ReportRow[]>("/reports/delivery-status")).data
  });
  async function download() {
    const response = await fetch("/api/v1/reports/delivery-status.csv", {
      credentials: "same-origin",
      headers: { "X-CSRF-Token": readCookie("tamween_csrf") ?? "" }
    });
    if (!response.ok) return;
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "tamween-delivery-status.csv";
    anchor.click();
    URL.revokeObjectURL(url);
  }
  return (
    <div className="page">
      <PageHeader
        title="التقارير"
        description="مؤشرات التغطية والانتظار بحسب الوحدة، دون كشف بيانات حساسة."
        actions={
          <button className="button button--secondary" type="button" onClick={download}>
            <Download aria-hidden="true" />
            تصدير CSV
          </button>
        }
      />
      {query.isPending ? (
        <LoadingState />
      ) : query.isError ? (
        <ErrorState error={query.error} retry={() => query.refetch()} />
      ) : (
        <section className="content-card">
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>الوحدة</th>
                  <th>الأسر</th>
                  <th>استلمت</th>
                  <th>لم تستلم</th>
                  <th>متوسط الانتظار</th>
                  <th>نسبة التغطية</th>
                </tr>
              </thead>
              <tbody>
                {query.data.map((row) => {
                  const percent = row.households ? Math.round((row.received / row.households) * 100) : 0;
                  return (
                    <tr key={row.unit_name}>
                      <td>
                        <strong>{row.unit_name}</strong>
                      </td>
                      <td>{formatNumber(row.households)}</td>
                      <td>{formatNumber(row.received)}</td>
                      <td>{formatNumber(row.never_received)}</td>
                      <td>{formatNumber(row.average_wait_days)} يوم</td>
                      <td>
                        <div className="progress-label">
                          <progress value={row.received} max={row.households}>
                            {percent}%
                          </progress>
                          <span>{formatNumber(percent)}٪</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </div>
  );
}
